<ion-header
  class="ion-no-border"
  *ngIf="(platformService?.isTouchExperience$ | async) === false"
>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button data-cy="close-modal-button" (click)="closeModal()">
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content
  [class.is-tablet]="
    platformService?.platformType === platformService?.platformEnum?.tablet
  "
  [class.is-mobile]="
    platformService?.platformType === platformService?.platformEnum?.mobile
  "
  [class.is-cancel-payment]="isCancelPayment"
>
  <section class="details-header" *ngIf="!isCancelPayment; else cancelHeader">
    <h2 data-cy="payment-reference">
      {{ 'i18n.payments.cancelPayment.referenceNumber' | translate }}:
      <span data-cy="payment-reference-value">
        {{ paymentDetails.referenceNumber }}
      </span>
    </h2>
    <h2
      *ngIf="
        platformService?.platformType !== platformService?.platformEnum?.mobile
      "
      data-cy="payment-total-amount"
    >
      {{ 'i18n.payments.cancelPayment.totalAmount' | translate }}:
      <span data-cy="payment-total-amount-value">
        {{ paymentDetails.totalPaymentAmount | currency }}
      </span>
    </h2>
  </section>

  <ng-template #cancelHeader>
    <section class="cancel-section" *ngIf="isCancelPayment">
      <ion-icon
        class="cancel-icon"
        data-cy="cancel-payment-icon"
        name="alert-circle-outline"
      ></ion-icon>
      <div class="cancel-labels">
        <h2 class="cancel-title" data-cy="cancel-payment-title">
          {{
            (paymentDetails.userHasAccessToAllCusts
              ? 'i18n.payments.cancelPayment.title'
              : 'i18n.payments.cancelPayment.unableToCancel'
            ) | translate
          }}
        </h2>
        <h4 class="cancel-subtitle" data-cy="cancel-payment-subtitle">
          {{
            (paymentDetails.userHasAccessToAllCusts
              ? 'i18n.payments.cancelPayment.subtitle'
              : 'i18n.payments.cancelPayment.noAccessToCancelMsg'
            ) | translate
          }}
        </h4>
      </div>
    </section>
  </ng-template>
  <ion-grid>
    <ion-row class="payment-details-header" data-cy="payment-details-header">
      <ion-row>
        <ion-col
          size-lg="auto"
          size-md="auto"
          size-sm="auto"
          size-xs="12"
          data-cy="payment-date"
        >
          {{
            (isCancelPayment
              ? 'i18n.payments.cancelPayment.scheduled'
              : 'i18n.payments.cancelPayment.processed'
            ) | translate
          }}: <span>{{ formatDate(paymentDetails.paymentDate) }}</span></ion-col
        ><ion-col
          size-lg="auto"
          size-md="auto"
          size-sm="auto"
          size-xs="12"
          data-cy="payment-amount-items"
        >
          {{ 'i18n.payments.cancelPayment.items' | translate }}:
          <span>{{ paymentDetails.itemCount }}</span></ion-col
        ><ion-col
          size-lg="auto"
          size-md="auto"
          size-sm="auto"
          size-xs="12"
          data-cy="payment-amount-customers"
        >
          {{ 'i18n.payments.cancelPayment.customers' | translate }}:
          <span>{{ paymentDetails.customerCount }}</span></ion-col
        ><ion-col
          size-lg="auto"
          size-md="auto"
          size-sm="auto"
          size-xs="12"
          data-cy="payment-method"
        >
          {{ 'i18n.payments.cancelPayment.paymentMethod' | translate }}:
          <span>{{ paymentDetails.paymentMethod }}</span></ion-col
        ></ion-row
      >
      <div
        *ngIf="
          isCancelPayment ||
            platformService?.platformType ===
              platformService?.platformEnum?.mobile;
          else downloadButtons
        "
        data-cy="payment-total-amount"
      >
        {{ 'i18n.payments.cancelPayment.totalAmount' | translate }}:
        <span>{{ paymentDetails.totalPaymentAmount | currency }}</span>
      </div>

      <ng-template #downloadButtons>
        <div class="download-container">
          <app-share-print-download
            [isMobile]="
              platformService?.platformType ===
              platformService?.platformEnum?.mobile
            "
            [showPrint]="
              platformService?.platformType ===
              platformService?.platformEnum?.desktop
            "
            (downloadButtonClick)="downloadPaymentDetails()"
            (printButtonClick)="printPaymentDetails()"
          ></app-share-print-download>
        </div>
      </ng-template>

      <ion-col
        *ngIf="
          !isCancelPayment &&
          platformService?.platformType ===
            platformService?.platformEnum?.mobile
        "
      >
        <ion-button
          data-cy="download-button"
          class="usf-outline-green-mobile-modal-button"
        >
          {{ 'i18n.common.download' | translate }}
        </ion-button>
      </ion-col>
    </ion-row>
    <section
      class="customer-section"
      *ngFor="let customer of customersSorted; let i = index"
    >
      <ion-row class="customer-header" [attr.data-cy]="'customer-header-' + i"
        ><ion-col
          [attr.data-cy]="'customer-name-' + i"
          size="auto"
          [class.inaccessible-customer]="!customer.userHasAccessToCust"
          >{{ customer.customerName | uppercase }}
          <span [attr.data-cy]="'customer-number-' + i"
            >#{{ customer.customerNumber }}</span
          >
          <span
            *ngIf="!customer.userHasAccessToCust"
            [attr.data-cy]="'inaccessible-customer-' + i"
            class="inaccessible-customer-msg"
            >{{
              'i18n.payments.paymentActivity.referenceOnly' | translate
            }}</span
          ></ion-col
        ><ion-col
          *ngIf="
            platformService?.platformType !==
            platformService?.platformEnum?.mobile
          "
          [attr.data-cy]="'customer-total-amount-' + i"
          >{{ customer.paymentAmount | currency }}</ion-col
        ></ion-row
      >
      <ng-container *ngIf="customer.userHasAccessToCust">
        <ion-row
          *ngFor="let transaction of customer.invoices; let j = index"
          class="transaction-row"
          [attr.data-cy]="'customer-' + i + '-transaction-' + j"
        >
          <ion-col
            size-lg="5"
            size-md="5"
            size-xs="12"
            [attr.data-cy]="'customer-' + i + '-transaction-main-' + j"
          >
            {{ transaction.transactionDescription }} #:
            <a
              [class.plain-text]="!transaction?.isr?.docID"
              (click)="!!transaction?.isr?.docID && viewInvoice(transaction)"
              href="javascript:void(0)"
            >
              {{
                transaction.secondaryTransaction
                  ? transaction.secondaryTransaction
                  : transaction.originalTransaction
              }}
            </a>
            <span
              *ngIf="hasSecondaryTransaction(transaction)"
              [attr.data-cy]="
                'customer-' + i + '-transaction-secondary-transaction' + j
              "
              >- {{ 'i18n.payments.transactionRow.invoice' | translate }} #:
              {{ transaction.originalTransaction }}</span
            ></ion-col
          ><ion-col
            size-lg="4"
            size-md="4"
            size-xs="12"
            [attr.data-cy]="'customer-' + i + '-transaction-date' + j"
            >{{ 'i18n.payments.cancelPayment.documentDate' | translate }}:
            <span
              [attr.data-cy]="'customer-' + i + '-transaction-date-value-' + j"
              >{{ formatDate(transaction.issueDate) }}</span
            > </ion-col
          ><ion-col
            size-lg="3"
            size-md="3"
            size-xs="12"
            [attr.data-cy]="'customer-' + i + '-transaction-amount-' + j"
          >
            <span class="payment-amount">
              {{ 'i18n.payments.cancelPayment.amount' | translate }}:
            </span>
            {{ transaction.payAmount | currency }}</ion-col
          >
        </ion-row>
      </ng-container>
      <div
        *ngIf="
          platformService?.platformType ===
          platformService?.platformEnum?.mobile
        "
        [attr.data-cy]="'customer-total-amount-' + i"
      >
        {{ customer.paymentAmount | currency }}
      </div>
    </section></ion-grid
  ></ion-content
>

<ion-footer class="ion-footer-modal">
  <ion-toolbar>
    <ion-buttons
      [class.show-in-columns]="
        !isCancelPayment &&
        platformService?.platformType !== platformService?.platformEnum?.desktop
      "
    >
      <ion-button
        *ngIf="paymentDetails.userHasAccessToAllCusts && canCancel"
        data-cy="yes-modal-button"
        class="usf-outline-green-mobile-modal-button"
        (click)="submitCancel()"
      >
        {{
          (isCancelPayment
            ? 'i18n.common.yes'
            : 'i18n.payments.cancelPayment.cancelPayment'
          ) | translate
        }}
      </ion-button>
      <ion-button
        data-cy="close-modal-button"
        class="usf-fill-green-mobile-modal-button"
        (click)="closeModal()"
      >
        {{
          (paymentDetails.userHasAccessToAllCusts && isCancelPayment
            ? 'i18n.common.no'
            : 'i18n.common.close'
          ) | translate
        }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
